import { Icon } from './styles'

export default Icon
